import { colors } from '../components/home/v4/styledComponents';

// Constants (from v2)
const contentWidth = 1180;
const tabletThreshold = 1180;
const tabletThresholdPixels = `${tabletThreshold}px`;
const mobileThreshold = 720;
const mobileThresholdPixels = `${mobileThreshold}px`;
const menuBarHeight = 55;
const menuBarHeightWithBanner = 130;
const menuBarHeightPixels = `${menuBarHeight}px`;
const menuBarHeightWithBannerPixels = `${menuBarHeightWithBanner}px`;
const mobileMenuBarHeight = 45;
const mobileMenuBarHeightWithBanner = 130;
const mobileMenuBarHeightPixels = `${mobileMenuBarHeight}px`;
const mobileMenuBarHeightWithBannerPixels = `${mobileMenuBarHeightWithBanner}px`;

// fontSizes (from v3)
const fontSizes = {
  xs: '12px',
  s: '15px',
  m: '18px',
  l: '24px',
  xl: '30px',
  x2l: '36px',
  x3l: '46px',
  x4l: '50px',
};

export default {
  contentWidth,
  tabletThreshold,
  tabletThresholdPixels,
  mobileThreshold,
  mobileThresholdPixels,
  menuBarHeight,
  menuBarHeightWithBanner,
  menuBarHeightPixels,
  menuBarHeightWithBannerPixels,
  mobileMenuBarHeight,
  mobileMenuBarHeightWithBanner,
  mobileMenuBarHeightPixels,
  mobileMenuBarHeightWithBannerPixels,
  colors,
  fontSizes,
};
